module.exports = __webpack_public_path__ + "img/4_170.44728a08.png";